import { Flex } from 'antd';
import styles from './channels.module.scss';
import { Channels as ChannelsModule } from '@modules/channels';

export const Channels = () => (
  <Flex className={styles.root} align="center" justify="center">
    <ChannelsModule />
  </Flex>
);
